import { Stack, Typography } from "@mui/material";
import { Flex } from "Components/_Shared/Core/Flex";
import { HStack } from "Components/_Shared/Core/Stack";
import { Spacing } from "Infrastructure/Themes/Themes";
import type { GoalHorizonHeaderData } from "./types";

type Props = {
  title: string;
  data?: GoalHorizonHeaderData[];
};

export const GoalHorizonHeader = ({ title, data = [] }: Props) => {
  return (
    <Flex justifyContent={"space-between"} alignItems={"center"} width={"100%"}>
      <Typography variant="subtitle1" fontWeight={600} py={Spacing.XL}>
        {title}
      </Typography>
      <HStack>
        {data.map((item, index) => {
          return (
            <Stack key={`${item.title}-${index}`} spacing={Spacing.XS} alignItems={"flex-end"} pr={Spacing.L}>
              <Typography variant="body1" fontWeight={500} fontSize={11} textTransform="uppercase" color="textSecondary">
                {item.title}
              </Typography>
              <Typography variant="body1" fontWeight={500} fontSize={14} color="textPrimary">
                {item.value}
              </Typography>
            </Stack>
          );
        })}
      </HStack>
    </Flex>
  );
};
